import React, { useEffect, useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { PLC_STATUS_OBSERVE_SPAN } from '../../../Constant';
import { useTranslation } from 'react-i18next';

export type PLC_COLMNG = {
  PLC_NO: number;
  EST: number;
  STAT_CON: number;
  STAT_SAV: number;
  ERR_MES: string;
};

// スタイル定義用のフック関数が受け取るプロパティの型
type StyleProps = {
  isStatusOk: boolean;
};

const useStyles = makeStyles<Theme, StyleProps>({
  paper: {
    height: '100%',
    background: (props) => (props.isStatusOk ? '#4CAF50' : '#FF0000'),
    color: '#FFFFFF',
    textAlign: 'center',
  },
});

const PLSStateCard: React.FC = () => {
  const { t } = useTranslation();
  const [plcState, setPlcState] = useState<PLC_COLMNG[]>([]);

  const getData = () => {
    fetch('api/PLCColmNg')
      .then((res) => res.json())
      .then(
        (result: PLC_COLMNG[]) => {
          setPlcState(result);
        },
        (error) => {
          console.debug(error);
        }
      );
  };

  useEffect(() => {
    getData();
    const interval = setInterval(() => {
      getData();
    }, PLC_STATUS_OBSERVE_SPAN); //  intervals

    return () => {
      clearInterval(interval);
    };
  }, []);

  //全接続状態 判定
  const isOk = plcState.length > 0 && plcState.every((row) => row.STAT_CON === 1);

  const classes = useStyles({ isStatusOk: isOk });

  return (
    <Paper className={classes.paper}>
      <Typography variant="h6">
        {isOk ? t('PLSStateCard.収集OK', '収集OK') : t('PLSStateCard.PLC未接続', 'PLC未接続')}
      </Typography>
    </Paper>
  );
};

export default PLSStateCard;
